// user types
export const CITIZEN = 'citizen';
export const ECC_USER = 'ecc_user';

// contstants for telnyx/video's event listeners/room events
// https://developers.telnyx.com/docs/video/javascript-sdk/room-events
export const CONNECTED = 'connected';
export const DISCONNECTED = 'disconnected';
export const STATE_CHANGED = 'state_changed';
export const STREAM_PUBLISHED = 'stream_published';
export const STREAM_UNPUBLISHED = 'stream_unpublished';
export const SUBSCRIPTION_STARTED = 'subscription_started';
export const TRACK_DISABLED = 'track_disabled';
export const PARTICIPANT_JOINED = 'participant_joined';
export const PARTICIPANT_LEAVING = 'participant_leaving';
export const PARTICIPANT_LEFT = 'participant_left';

export const CONSTRAINTS_DEFAULT = {
  audio: true,
  video: true,
};

export const FACING_MODE_USER = 'user';
export const FACING_MODE_ENVIRONMENT = 'environment';
export const CONSTRAINTS_BACK_CAMERA = {
  ...CONSTRAINTS_DEFAULT,
  video: { facingMode: FACING_MODE_ENVIRONMENT }, // back camera
};
